import script from "./NotesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./NotesCard.vue?vue&type=script&setup=true&lang=js"

import "./NotesCard.vue?vue&type=style&index=0&id=05b820c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05b820c8"]])

export default __exports__